import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import 'gsap/CSSPlugin';
gsap.registerPlugin(ScrollTrigger);

const Scroll = {
	init() {
		let headings = document.querySelectorAll(
			'.reveal .wp-block-heading, .reveal .has-text-align-center'
		);
		headings.forEach((heading) => {
			//wrap each content of the heading in a span
			heading.innerHTML = heading.textContent.replace(
				/(\S+)/g,
				'<span>$1</span>'
			);
		});

		gsap.utils
			.toArray('.reveal, .tribe-events-widget-events-list')
			.forEach(function (elem) {
				ScrollTrigger.create({
					once: true,
					start: 'top 80%',
					end: '0% -10000%',
					trigger: elem,
					toggleClass: 'enable',
				});
			});

		let autoscroll = document.querySelector('.auto-scroll');
		if (autoscroll) {
			autoscroll.addEventListener('click', function () {
				// scroll one page down
				window.scrollTo({
					top: window.innerHeight,
					behavior: 'smooth',
				});
			});
		}
	},
};

export default Scroll;
